export const tags = [
    { id: 'categories', label: 'Category Pages' },
    { id: 'entities', label: 'Top Entities' },
    { id: 'authors', label: 'Top Authors' },
];
